export enum PackContentTab {
  Assets,
  Flows,
  Communications,
  Events,
  Campaigns,
}
